import React from 'react'

import slug from "limax";


import ImageEdit from "./components/common/ImageEdit";
import AsyncSelect from "./components/common/AsyncSelect";
import Select from "./components/common/CustomSelect";
import Section from './components/common/Section'

import Div from './components/layouts/Div'

import Fees, {buildDefaultSchemes} from "./components/package/Fees";

import { TAX, FEE_INFO_PACKAGE_DETAIL } from '../constants/Variables';

import Backend from "../utils/Backend"
import General from "../utils/General";
import Notify from "../utils/Notify"
import Currency from "../utils/Currency";
import Calculations from "../utils/Calculations";

const FREQUENCY_OPTIONS = [
  {
    label: "Monthly",
    value: "monthly"
  },
  {
    label: "Yearly",
    value: "yearly"
  },
  {
    label: "Once Off",
    value: "one_time"
  }
]

export default class PackageModal extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      ...this._getState(props),
      mode: "package",
      loading: false,
      error: null,
      feeErrors: null,
      selectedType: "per_payment_method",
      processors: []
    }

  }

  componentDidMount() {
    Backend.getProcessors()
      .then(processors => this.setState({ processors }))

    let id =  this.props.match.params.package_id
    if (id) {
      this._setupPackage(id)
    } else {
      this.setState({ loading: false })
    }
  }

  _setupPackage(id) {
    this.setState({ packageObject: null })
    Backend.getPackage(id)
      .then((packageObject) => {
        packageObject.vat_percentage = Calculations.getPercentageRate(packageObject.total, packageObject.subtotal)
        this.setState({ packageObject, loading: false })
      })
      .catch((error) => {
        Notify.error(error.message)
      })
  }

  componentWillReceiveProps(nextProps) {
    this.setState(this._getState(nextProps))
  }

  _getState(props) {
    return {
      ...props,
      packageObject: props.packageObject || {
        currency: window.General.DefaultCurrency,
        add_ons: {},
        benefits: [],
        free_trial_days: 0,
        rates: {
          type: "scheme",
          default: {
            card: null,
            default: true
          },
          schemes: buildDefaultSchemes("package")
        }
      },
    }
  }

  _handleChange(e) {
    let packageObject = this.state.packageObject
    packageObject[e.target.name] = e.target.value
    this.setState({ packageObject, error: null })
  }

  _isFormValid() {
    let {
      packageObject
    } = this.state

    let error = null

    if (packageObject.name == null || packageObject.name.length === 0) {
      error = "Please enter a package name"
    } else if (packageObject.slug == null || packageObject.slug.length === 0) {
      error = "Please enter a package slug"
    } else if (!/[a-z]/i.test(packageObject.slug)) {
      error = "Slug must contain at least 1 letter"
    } else if (packageObject.title == null || packageObject.title.length === 0) {
      error = "Please enter a package title"
    } else if (!packageObject.cta) {
      error = "Please enter a CTA"
    } else if (!packageObject.frequency) {
      error = "Please select a frequency"
    } else if (packageObject.total < 0) {
      error = "Please enter a valid price"
    } else if (packageObject.free_trial_days < 0) {
      error = "Please enter a valid free trial period"
    }

    if (error) {
      Notify.error(error)
      return false
    }
    return true
  }

  _handleUpdatePackage() {
    let {
      packageObject
    } = this.state

    if (!this._isFormValid()) {
      return
    }

    if (this.state.packageObject.id) {
      this._updatePackage(packageObject)
    } else {
      this._createPackage(packageObject)
    }
  }

  _createPackage(packageObject) {
    this.setState({ loading: true })
    Backend.createPackage(packageObject)
      .then(packageObject => {
        Notify.success("Package Created Successfully")
        this.setState({ loading: false, feeErrors: null })
        this.props.history.push("/packages")
      })
      .catch(error => {
        this.setState({ loading: false, feeErrors: error.raw?.rates?.schemes || null })
        let errorMessage = error.message;
        Notify.error(errorMessage)
      })
  }

  _updatePackage(packageObject) {
    this.setState({ loading: true })
    Backend.updatePackage(packageObject)
      .then(packageObject => {
        Notify.success("Package Updated Successfully")
        this.setState({ loading: false, feeErrors: null })
        this.props.history.push("/packages")
      })
      .catch(error => {
        this.setState({ loading: false, feeErrors: error.raw?.rates?.schemes || null })
        let errorMessage = error.message;
        Notify.error(errorMessage)
      })
  }

  _renderItem(item, index) {
    let {
      packageObject
    } = this.state

    return (
      <>
        <div className={"row mb-3"}>
          <div className={"col-8"}>
            <input
              type="text"
              className="form-control form-control-solid"
              placeholder={"Title"}
              value={packageObject.benefits[index]?.title || ''}
              onChange={e => {
                packageObject.benefits[index].title = e.target.value
                this.setState({ packageObject })
              }}
            />
          </div>
        </div>
        <div className={"row mb-3"}>
          <div className={"col-8"}>
            <input
              type="text"
              className="form-control form-control-solid"
              placeholder={"Subtitle"}
              value={packageObject.benefits[index]?.subtitle || ''}
              onChange={e => {
                packageObject.benefits[index].subtitle = e.target.value
                this.setState({ packageObject })
              }}
            />
          </div>
        </div>
      </>
    )
  }

  _renderDelete(item, index) {
    let {
      packageObject
    } = this.state

    return (
      <a href="javascript:;" data-repeater-delete=""
         className="btn font-weight-bold btn-danger btn-icon"
         onClick={() => {
           packageObject.benefits.splice(index, 1)
           this.setState({ packageObject })
         }}
      >
        <i className="la la-remove"></i>
      </a>
    )
  }

  _renderSection(
    title,
    content,
    collapsed = false,
    collapsible = false,
    subtitle = null
  ) {
    return (
      <Section
        title={title}
        subtitle={subtitle}
        content={content}
        collapsed={collapsed}
        collapsible={collapsible}
      />
    )
  }

  _renderFeesSection() {
    const { packageObject, processors, feeErrors } = this.state;

    return (
      <Fees
        mode={"package"}
        infoText={FEE_INFO_PACKAGE_DETAIL}
        packageObject={packageObject}
        processors={processors}
        errors={feeErrors}
        rates={packageObject.rates}
        onUpdate={(rates) => {
          packageObject.rates = rates
          this.setState({ packageObject })
        }}
      />
    )
  }

  render() {
    let {
      show,
      packageObject,
      loading,
    } = this.state

    if (!packageObject) return null

    let title = packageObject.id ? "Update Package" : "Create Package";
    let buttonTitle = packageObject.id ? 'Update' : 'Create';

    let platformRate = parseFloat(packageObject.platform_rate) ? Math.round((packageObject.platform_rate * 100) * 100) / 100 : ''
    let clientCut = parseFloat(packageObject.rate) ? Math.round((packageObject.rate * 100) * 100) / 100 : ''
    let partnerCut = parseFloat(packageObject.association_rate) ? Math.round((packageObject.association_rate * 100) * 100) / 100 : ''

    let platformFixedCharge = packageObject.platform_flat_charge ? packageObject.platform_flat_charge / 100 : ""
    let partnerFixedCharge = packageObject.association_flat_charge ? packageObject.association_flat_charge / 100 : ""

    let price = packageObject.subtotal ? (packageObject.subtotal / 100) : ''
    let percentage = packageObject.vat_percentage ? Math.round((packageObject.vat_percentage * 100) * 100) / 100 || '' : Math.round((Calculations.getPercentage(packageObject.total, packageObject.subtotal)) * 100) / 100 || ''
    let vatEnabled = percentage > 0 || packageObject.enableVat
    let minPayment = packageObject.min_payment ? (packageObject.min_payment / 100) : ''

    let formClassName = ''

    let isCompanyDetail = this.props.variation === "company-detail";

    return (
      <Div
        className={`row custom-form ${formClassName}`}
        disabled={loading}
        showLoadingIndicator={true}
      >
        <div className="col-12">

          {!isCompanyDetail &&
            <>
              {/* starts : 01 Section Details */}
              {this._renderSection(
                'Details',
                <div className="section details">

                  {/* starts : Package Name */}
                  <div className="form-group row">
                    <label className="col-lg-3 col-form-label">Package Name*</label>
                    <div className="col-lg-9 my-auto">
                      <input
                        type="text"
                        name="name"
                        placeholder={'Package Name'}
                        className="form-control form-control-solid"
                        value={packageObject.name}
                        onChange={e => this._handleChange(e)}
                        onBlur={() => {
                          packageObject.slug = packageObject.slug || slug(packageObject.name || "")
                          this.setState({ packageObject })
                        }}
                      />
                    </div>
                  </div>
                  {/* end : Package Name */}

                  {/* starts : Slug */}
                  <div className="form-group row">
                    <label className="col-lg-3 col-form-label">
                      Slug*
                    </label>
                    <div className="col-lg-9 my-auto">
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <span className="input-group-text" style={{ border: 'none' }}>dashboard.{window.General.WebsiteDomain}/account?u=c&p=</span>
                        </div>
                        <input
                          className="form-control form-control-solid"
                          type="text"
                          value={packageObject.slug}
                          name={"slug"}
                          disabled={!!packageObject.id}
                          onChange={e => this._handleChange(e)}
                          onBlur={() => {
                            packageObject.slug = slug(packageObject.slug || "")
                            this.setState({ packageObject })
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  {/* end : Slug */}

                  {/* starts : Package Title */}
                  <div className="form-group row">
                    <label className="col-lg-3 col-form-label">Title*</label>
                    <div className="col-lg-9 my-auto">
                      <input
                        type="text"
                        name="title"
                        placeholder={'Package Title'}
                        className="form-control form-control-solid"
                        value={packageObject.title}
                        onChange={e => this._handleChange(e)}
                      />
                    </div>
                  </div>
                  {/* end : Package Title */}

                  {/* starts :Subtitle */}
                  <div className="form-group row">
                    <label className="col-lg-3 col-form-label">Subtitle</label>
                    <div className="col-lg-9 my-auto">
                      <input
                        type="text"
                        name="subtitle"
                        placeholder={'Package Subtitle'}
                        className="form-control form-control-solid"
                        value={packageObject.subtitle}
                        onChange={e => this._handleChange(e)}
                      />
                    </div>
                  </div>
                  {/* end : Package Subtitle */}

                  {/* starts :Description */}
                  <div className="form-group row">
                    <label className="col-lg-3 col-form-label">Description</label>
                    <div className="col-lg-9 my-auto">
                      <textarea
                        name="description"
                        rows="3"
                        placeholder={'Package Description'}
                        className="form-control form-control-solid"
                        value={packageObject.description}
                        onChange={e => this._handleChange(e)}
                      />
                    </div>
                  </div>
                  {/* end : Package Description */}

                  {/* starts :Background Image */}
                  <div className="form-group row">
                    <label className="col-lg-3 col-form-label">Background Image</label>
                    <div className="col-lg-9 my-auto">
                      <ImageEdit
                        image={packageObject.background}
                        hidePreview={false}
                        deletable={true}
                        imagePicker={true}
                        type={"banner"}
                        onUpdated={image => {
                          this.setState({ loading: false })
                          packageObject.background = image
                          this.setState({ packageObject, error: null })
                        }}
                        onDeleteClicked={() => {
                          packageObject.background = null
                          this.setState({ packageObject, error: null })
                        }}
                      />
                    </div>
                  </div>
                  {/* end : Background Image */}

                  {/* starts : CTA */}
                  <div className="form-group row">
                    <label className="col-lg-3 col-form-label">CTA*</label>
                    <div className="col-lg-9 my-auto">
                      <input
                        className="form-control form-control-solid"
                        type="text"
                        placeholder={''}
                        value={packageObject.cta}
                        name={"cta"}
                        onChange={e => this._handleChange(e)}
                      />
                    </div>
                  </div>
                  {/* end : CTA */}

                </div>,
                false,
                true
              )}
              {/* end : 01 Section Details */}

              {/* starts : 02 Section Payments */}
              {this._renderSection(
                'Payments',
                <div className="section payments">

                  {/* starts : Frequency */}
                  <div className="form-group row">
                    <label className="col-lg-3 col-form-label">Frequency*</label>
                    <div className="col-lg-9 my-auto">
                      <Select
                        value={FREQUENCY_OPTIONS.find(frequency => frequency.value === packageObject.frequency)}
                        className="form-control h-auto border-0 form-control-solid c-selectbox"
                        name="account_holder_type"
                        placeholder="Please Select A Frequency"
                        onChange={option => {
                          packageObject.frequency = option.value
                          this.setState({ packageObject })
                        }}
                        options={FREQUENCY_OPTIONS}
                      />
                    </div>
                  </div>
                  {/* end : Frequency */}

                  {/* starts : Currency */}
                  <div className="form-group row">
                    <label className="col-lg-3 col-form-label">
                      Currency*
                    </label>
                    <div className="col-lg-9 my-auto">
                      <AsyncSelect
                        endpoint={window.Api.Currencies}
                        className={'custom-async-select__container'}
                        classNamePrefix={'custom-async-select'}
                        params={{}}
                        placeholder="Select A Currency"
                        value={packageObject.currency ? General.getSingleAsyncOption(packageObject.currency) : null}
                        onSelected={currency => {
                          packageObject.currency = currency
                          this.setState({ packageObject })
                        }}
                        getOptions={currencies => General.getAsyncOptions(currencies)}
                      />
                    </div>
                  </div>
                  {/* end : Currency */}

                  {/* starts : Price */}
                  <div className="form-group row">
                    <label className="col-lg-3 col-form-label">
                      Price
                    </label>
                    <div className="col-lg-9 my-auto">
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <span className="input-group-text border-0">{packageObject.currency.symbol}</span>
                        </div>
                        <input
                          className="form-control form-control-solid"
                          type="number"
                          value={price}
                          placeholder="0.00"
                          name="subtotal"
                          step={"0.01"}
                          onChange={(e) => {
                            packageObject["subtotal"] = Math.round(e.target.value * 100)
                            if (packageObject.vat_percentage) {
                              packageObject["total"] = Math.round(parseFloat(Calculations.totalIncludingVat(e.target.value * 100, packageObject.vat_percentage, false)))
                            } else {
                              packageObject["total"] = Math.round(e.target.value * 100)
                            }
                            packageObject["vat"] = packageObject["total"] - packageObject["subtotal"]
                            this.setState({ packageObject, error: null })
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-3"></div>
                    <div className="col-1 mt-3">
                      <span className="switch switch-outline switch-icon switch-primary">
                        <label>
                          <input
                            type="checkbox"
                            id="vatSelect"
                            checked={packageObject.enableVat || vatEnabled}
                            onChange={e => {
                              let show = e.target.checked
                              if (show) {
                                packageObject.enableVat = show
                                packageObject.vat_percentage = 0
                                packageObject.vat = Math.round(parseFloat(Calculations.totalVat(packageObject.subtotal, 0, false)))
                                packageObject.total = Math.round(parseFloat(Calculations.totalIncludingVat(packageObject.subtotal, 0, false)))
                              } else {
                                packageObject.enableVat = show
                                packageObject.vat_percentage = null
                                packageObject.vat = 0
                                packageObject.total = packageObject.subtotal
                              }
                              this.setState({ packageObject })
                            }}
                          />
                          <span></span>
                        </label>
                      </span>
                    </div>
                    <label htmlFor="vatSelect" className="col-6 col-form-label align-left mt-3">Enable {TAX}</label>
                    {
                      vatEnabled &&
                      <>
                        <div className="col-3"></div>
                        <div className="col-9">
                          <div className="row" id="vatOptions">
                            <div className="col-6">
                              <div className="input-group">
                                <div className="input-group-prepend">
                                  <span className="input-group-text" style={{ border: 'none' }}>%</span>
                                </div>
                                <input
                                  className="form-control form-control-solid"
                                  type="number"
                                  min={0}
                                  placeholder="0"
                                  name={"vat"}
                                  value={percentage}
                                  onChange={(e) => {
                                    packageObject["vat_percentage"] = e.target.value / 100
                                    packageObject["vat"] = Math.round(parseFloat(Calculations.totalVat(packageObject.subtotal, e.target.value / 100, false)))
                                    packageObject["total"] = Math.round(parseFloat(Calculations.totalIncludingVat(packageObject.subtotal, e.target.value / 100, false)))
                                    this.setState({ packageObject })
                                  }}
                                />
                              </div>
                            </div>
                            <div className="col-6">
                              <div className="input-group">
                                <div className="input-group-prepend">
                                  <span className="input-group-text">€</span>
                                </div>
                                <input
                                  className="form-control"
                                  type="text"
                                  placeholder="Total"
                                  value={Currency.format('', packageObject.total)}
                                  disabled="" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    }
                  </div>
                  {/* end : Price */}

                  {/* starts : Free Trial Days */}
                  <div className="form-group row">
                    <label className="col-lg-3 col-form-label">Free Trial Days</label>
                    <div className="col-lg-9 my-auto">
                      <input
                        className="form-control form-control-solid"
                        type="number"
                        placeholder='0'
                        defaultValue={packageObject.free_trial_days}
                        name={"free_trial_days"}
                        onChange={e => {
                          packageObject.free_trial_days = e.target.value || 0
                          this.setState({ packageObject })
                        }}
                      />
                    </div>
                  </div>
                  {/* end : Free Trial Days */}

                  {/* starts : Minimum Payment */}
                  <div className="form-group row">
                    <label className="col-lg-3 col-form-label">Minimum Payment</label>
                    <div className="col-lg-9 my-auto">
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <span className="input-group-text border-0">{packageObject.currency.symbol}</span>
                        </div>
                        <input
                          className="form-control form-control-solid"
                          type="number"
                          placeholder="0.00"
                          step={"0.01"}
                          value={minPayment}
                          onChange={e => {
                            packageObject.min_payment = parseFloat(e.target.value) * 100
                            this.setState({ packageObject })
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  {/* end : Minimum Payment */}

                </div>,
                false,
                true
              )}
              {/* end : 02 Section Payments */}

              {/* starts : 03 Section Fees */}
              {/*{this._renderSection(*/}
              {/*  'Fees',*/}
              {/*  this._renderFeesSection(),*/}
              {/*  false,*/}
              {/*  true*/}
              {/*)}*/}
              {/* end : 03 Section Fees */}
            </>
          }

          {/* starts : 03 Section Fees */}
          {/*{isCompanyDetail &&*/}
          {/*  <div className="kt-portlet">*/}
          {/*    <div className="kt-portlet__body">*/}
          {/*      {this._renderFeesSection()}*/}
          {/*    </div>*/}
          {/*  </div>*/}
          {/*}*/}
          {/* end : 03 Section Fees */}

          <div className="kt-portlet__foot">
            <div className="kt-form__actions pull-right">
              <button
                type="button"
                className="btn btn-primary ml-3"
                disabled={loading}
                onClick={() => this._handleUpdatePackage()}
              >
                {buttonTitle}
              </button>
            </div>
          </div>

        </div>

      </Div>

    )
  }

}
